/**
 * 路由表：大厅 / 两个游戏 / 个人账户 / 后台（登录 + 五个子页）。
 * 页面按需懒加载，首屏只要大厅。
 */
import { Suspense, lazy } from "react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import AgeGate from "./components/AgeGate.tsx";
import Layout from "./components/Layout.tsx";
import { Card, Spinner } from "./components/ui.tsx";

const Lobby = lazy(() => import("./pages/Lobby.tsx"));
const Account = lazy(() => import("./pages/Account.tsx"));
const TributeCards = lazy(() => import("./pages/GameTributeCards.tsx"));
const AeroplaneChess = lazy(() => import("./pages/GameAeroplaneChess.tsx"));

const AdminLogin = lazy(() => import("./pages/admin/AdminLogin.tsx"));
const AdminLayout = lazy(() => import("./pages/admin/AdminLayout.tsx"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard.tsx"));
const AdminContent = lazy(() => import("./pages/admin/AdminContent.tsx"));
const AdminRooms = lazy(() => import("./pages/admin/AdminRooms.tsx"));
const AdminReports = lazy(() => import("./pages/admin/AdminReports.tsx"));
const AdminSettings = lazy(() => import("./pages/admin/AdminSettings.tsx"));

function NotFound() {
  return (
    <Card className="text-center">
      <h2 className="neon-title text-2xl">这里什么都没有</h2>
      <p className="mt-2 text-sm text-cream-dim">页面不存在，或者游戏还没上线。</p>
      <Link to="/" className="btn-primary mt-4 inline-flex">
        回大厅
      </Link>
    </Card>
  );
}

export default function App() {
  return (
    <AgeGate>
      <Suspense fallback={<Spinner />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Lobby />} />
            <Route path="/account" element={<Account />} />
            <Route path="/g/tribute-cards" element={<TributeCards />} />
            <Route path="/g/aeroplane-chess" element={<AeroplaneChess />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            {/* 旧的「主页配置」已并入设置中心的「基础信息」分区，保留旧地址做跳转 */}
            <Route path="profile" element={<Navigate to="/admin/settings?tab=profile" replace />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="rooms" element={<AdminRooms />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </Suspense>
    </AgeGate>
  );
}
